import { render, staticRenderFns } from "./DrawerList.vue?vue&type=template&id=480ab21a"
import script from "./DrawerList.vue?vue&type=script&lang=js"
export * from "./DrawerList.vue?vue&type=script&lang=js"
import style0 from "./DrawerList.vue?vue&type=style&index=0&id=480ab21a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports